<template>
  <div class="h-[140] gg-wrap" v-if="adVisible">
    <div v-if="adList.length > 0" class="relative">
      <el-carousel height="140px" trigger="click" :indicator-position="adList.length > 1 ? 'bottom' : 'none'"
        arrow="never" :interval="5000">
        <el-carousel-item v-for="item in adList" :key="item.id">
          <a @click="handleClickAd(item)">
            <img :src="item.imageUrl" class="w-[100%] h-[100%]" alt="">
          </a>
        </el-carousel-item>
      </el-carousel>
      <div class="absolute top-[16] right-[16] z-[10]">
        <i class="icon t-[12] t-[#cccccc] font-600" @click="adVisible = false">&#xe641;</i>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  name: 'dg-gg',
  mixins: [mixin],
  data() {
    return {
      adList: [],
      adVisible: true,
      formData: {
        taction: this.$route.query.taction, // 订单业务动作
        token: this.$route.query.token, // token
        tradeNo: this.$route.query.tradeNo, // 订单号
        tv: this.$route.query.tv, // token版本号
        udp: this.$route.query.udp, // 用户所处的设备端
      },
    }
  },
  methods: {
    getAd() {
      ajax.post({
        url: "/customer/advertisingPosition/external/listOfAds",
        data: {
          ...this.formData,
        },
        success: (res) => {
          if (res) {
            this.adList = res || [];
            console.log(this.adList, '广告');

          }
        },
      });
    },

    handleClickAd(item) {
      let url = '';
      if (this.$route.query.token) {
        url = "/customer/advertisingPosition/external/clickAds"
      } else {
        url = "/customer/homePageData/clickAds"
      }
      ajax.post({
        url,
        data: {
          ...this.formData,
          adId: item.id,
        },
        success: (res) => {
          if (res) {
            window.fixOpen(item.jumpParams);
          }
        },
        fail: () => {
          window.fixOpen(item.jumpParams);
        }
      });
    },

  },
  mounted() {
    this.getAd()
  }
}
</script>
<style lang="less" scoped>
.gg-wrap {
  /deep/.el-carousel__button {
    width: 15px;
    height: 4px;
    border-radius: 10px;
  }

  &.none_indicator {
    /deep/.el-carousel__indicators {
      display: none;
    }
  }
}
</style>
